import React from "react";
import { Modal, Table, message } from "antd";
import { CopyOutlined } from "@ant-design/icons";

const EmployeeBulkFullInfoModal = ({ visible, onClose, employee }) => {
  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    message.success("Copied!");
  };

  const columns = [
    {
      key: "detailName",
      width: 200,
      render: (text, record) => record.detailName,
    },
    {
      key: "text",
      render: (text, record) => record.text,
    },
  ];

  const data = [
    {
      detailName: "Name",
      text: employee.name,
    },
    {
      detailName: "Email",
      text: (
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <a href={`mailto:${employee.email}`}>{employee.email}</a>
          <CopyOutlined
            onClick={() => handleCopy(employee.email)}
            style={{ cursor: "pointer" }}
          />
        </div>
      ),
    },
    {
      detailName: "Manager",
      text: employee.manager ? (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between"
          }}
        >
          {employee.manager}
        </div>
      ) : null,
    },
    {
      detailName: "Career Coach",
      text: employee.careerCoach ? (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between"
          }}
        >
          {employee.careerCoach}
        </div>
      ) : null,
    },
    {
      detailName: "PTO Modifier",
      text: employee.ptoModifier,
    },
    {
      detailName: "PTO Hours Override",
      text: employee.ptoHoursOverride,
    },
    {
      detailName: "Contractor Rate",
      text: employee.contractorRate,
    },
    {
      detailName: "Practice",
      text: employee.practiceName,
    },
    {
      detailName: "Psa Instances",
      text: employee.psaInstances,
    },
    {
      detailName: "Primary Psa Instance",
      text: employee.primaryPsaInstance,
    },
    {
      detailName: "Errors",
      text: (<pre style={{ fontSize: "0.8em" }}>{employee.errors}</pre>),
    },
    {
      detailName: "ID",
      text: (
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          {employee.id}
          <CopyOutlined
            onClick={() => handleCopy(employee.id)}
            style={{ cursor: "pointer" }}
          />
        </div>
      ),
    },
  ];

  return (
    <Modal
      title="Employee Bulk Upload Full Information"
      open={visible}
      onCancel={onClose}
      width={1400}
      footer={null}
    >
      <Table
        columns={columns}
        dataSource={data}
        pagination={false}
        rowKey="detailName"
        showHeader={false}
      />
    </Modal>
  );
};

export default EmployeeBulkFullInfoModal;
